import React from 'react';
import PropTypes from 'prop-types';
import { Flex } from '../flex';
export const Grid = _ref => {
  let {
    children
  } = _ref;
  return /*#__PURE__*/React.createElement(Flex, {
    extend: gridCSS
  }, children);
};
Grid.propTypes = {
  /** A JSX node */
  children: PropTypes.node.isRequired
};

const gridCSS = _ref2 => {
  let {
    theme
  } = _ref2;
  return {
    boxSizing: 'border-box',
    width: '100%',
    maxWidth: 1400,
    margin: '0 auto',
    paddingLeft: theme.baselineGrid * 2,
    paddingRight: theme.baselineGrid * 2,
    // We use onlyM here so that breakpoint orders don't need to be defined by the user
    onlyM: {
      paddingLeft: theme.baselineGrid * 3,
      paddingRight: theme.baselineGrid * 3
    },
    fromL: {
      paddingLeft: theme.baselineGrid * 5,
      paddingRight: theme.baselineGrid * 5
    }
  };
};